import { HttpClient } from '@angular/common/http';
import { AppConfigSettings } from '@arc/arc-shared-frontend';
import {
  SessionGuestCheckoutService,
  SessionPaymentLinksService,
  SessionPlatformService,
  SessionService,
} from '../services';
import { Injectable } from '@angular/core';

export const sessionServiceFactory = (
  httpClient: HttpClient,
  appConfig: AppConfigSettings,
) => {
  let service: SessionService;

  if (appConfig.getconfig('usePaymentLinkEndpoints') === 'true') {
    service = new SessionPaymentLinksService(httpClient, appConfig);
  } else if (appConfig.getconfig('useHostedPaymentsPageEndpoints') === 'true') {
    service = new SessionGuestCheckoutService(httpClient, appConfig);
  } else {
    service = new SessionPlatformService(httpClient, appConfig);
  }

  return service;
};

@Injectable({
  providedIn: 'root',
})
export class SessionServiceFactory {
  constructor(
    private httpClient: HttpClient,
    private appConfig: AppConfigSettings,
  ) {}

  create() {
    return sessionServiceFactory(this.httpClient, this.appConfig);
  }
}
